import SortableObjects from 'ember-drag-drop/components/sortable-objects';

export default SortableObjects;
